import React, { useEffect, useState } from "react";
import checkedIcon from "../../../../assets/check-mark.png";
import deleteIcon from "../../../../assets/trash.png";
import closeIcon from "../../../../assets/closeModel.png";
import Popup from "../../../../components/common/model/Popup";
import { DialogContent, DialogContentText, Grid } from "@mui/material";
import Notification from "../../../../components/common/notification/Notification";
import FormField from "../../../../components/common/FormField";
import useStyles from "../../../../components/common/model/styles";
import { SERVICE_ALL_FIELDS } from "./serviceAllFields";
import { useDispatch } from "react-redux";
import Validation from "../../../../utils/Validation";
import {
  addVehicleServiceHistory,
  initialServiceLocalState,
} from "../../../../store/reducers/vehicleSlice";
import { setNotificationAction } from "../../../../store/reducers/mmymSlice";
import ResetFormAlert from "../ResetFormAlert";

interface ManageVehicleServiceProps {
  open: boolean; // Define the 'open' prop
  onHide: () => void; // Define the 'onHide' prop
  title: string; // Define the 'title' prop
  selectedService: any; // Adjust type as per your requirement
  selectedVehicleId?: any;
  action?: any;
  setSelectedService?: any;
}

const ManageVehicleService: React.FC<ManageVehicleServiceProps> = (props) => {
  const classes = useStyles();
  const {
    open,
    onHide,
    title,
    selectedService,
    selectedVehicleId,
    action,
    setSelectedService,
  } = props;
  const fullWidth = true;
  const maxWidth: "sm" | "md" | "lg" | "xl" | false | undefined = "md";
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [alerModeShow, setAlertModelShow] = useState(false);
  const [serviceDetails, setServiceDetails] = useState<any>(
    initialServiceLocalState
  );
   const [isClickReset, setIsClickReset] = useState(false);
  const dispatch = useDispatch();
  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
  ]: any = Validation({
    date: serviceDetails?.date,
    title: serviceDetails?.title,
  });

  const handleInputChange = (field: string, value: any) => {
    setServiceDetails((prevState: any) => ({
      ...prevState,
      [field]: value,
    }));

    resetValidator(field);
  };

  const onBlurAction = (event: any) => {
    checkValidator(event.target.id);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    setIsActionCalled(true);
    checkValidator();
  };

  useEffect(() => {
    if (isActionCalled) {
      if (!isError() && error !== null && isActionCalled) {
        dispatch(
          addVehicleServiceHistory({
            ...serviceDetails,
            vehicle_id: selectedVehicleId,
          })
        );
      }
      setIsActionCalled(false);
    }
  }, [isActionCalled]);

  const hideHandler = () => {
    onHide();
    setServiceDetails(initialServiceLocalState);
    dispatch(setNotificationAction({ type: "", message: "" }));
    resetAllValidator();
  };

  const handleClear = () => {
    setServiceDetails(initialServiceLocalState);
    // setSelectedService(null);
    resetAllValidator();
    setIsClickReset(false);
  };

   const openClearPopup = () => {
    setAlertModelShow(true);
  };

    useEffect(() => {
      if (isClickReset) {
        handleClear();
        setAlertModelShow(false);
      }
    }, [isClickReset]);

  return (
    <>
      <Popup
        open={open} // Example value, replace with your actual state or variable
        title={title} // Example title, replace with your actual title
        onHide={hideHandler}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        popupBg={"#fff"}
        aria-describedby="alert-dialog-slide-description"
        header={
          <>
            <img
              onClick={(e: any) => handleSubmit(e)}
              src={checkedIcon}
              className={classes.checkicons}
              // style={{ right: 40 }}
              alt="save"
            />
            <img
              onClick={openClearPopup}
              src={deleteIcon}
              className={classes.deleteicons}
              alt="delete"
            />
            <img
              onClick={hideHandler}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
      >
        <DialogContent sx={{ padding: "16px 10px !important" }}>
          <DialogContentText
            sx={{
              background: "#E5F4F1",
              padding: "10px 10px 10px 0px",
              border: "1px solid #CFCFCF",
              borderRadius: "5px",
            }}
          >
            <>
              <Notification />
              <Grid container spacing={1}>
                {SERVICE_ALL_FIELDS?.map((field, i) => {
                  let dynamicField = { ...field };
                  return (
                    <>
                      <FormField
                        key={field.id}
                        onPaste={(e: any) =>
                          field?.id === "name" || field?.id === "email"
                            ? ""
                            : e.preventDefault()
                        }
                        onKeyDown={(event: any) => {
                          if (
                            [8, 9, 37, 38, 39, 40, 18, 17].includes(
                              event.keyCode
                            ) ||
                            event.ctrlKey
                          )
                            return event;
                          if (
                            field?.patternAllowed &&
                            !field?.patternAllowed.test(event.key)
                          ) {
                            event.preventDefault();
                          } else if (
                            field?.patternAllowed &&
                            !field?.patternAllowed.test(
                              event.target.value + event.key
                            )
                          ) {
                            event.preventDefault();
                          }
                        }}
                        {...{
                          ...dynamicField,
                          value: serviceDetails
                            ? serviceDetails[dynamicField.id]
                            : "",
                          inSingleGridForm: true,
                          minDate:
                            field.id === "movingOnDate"
                              ? new Date()
                              : undefined,
                          // maxDate:
                          //   field.id === "followUpDate"
                          //     ? newLeadLocal?.movingOnDate &&
                          //       dayjs(newLeadLocal.movingOnDate)
                          //         .toDate()
                          //     : undefined,
                          variant: "outlined",

                          onChange: (e: any) =>
                            handleInputChange(field.id, e.target.value), // Call onChange prop
                          onBlur: onBlurAction,
                          isNonMarginTop: true,
                          GridFieldStyle: {
                            paddingLeft:
                              field.type === "daterangebothvalue" ||
                              field.type === "date"
                                ? "8px !important"
                                : "auto",
                          },
                          InputProps: {
                            ...(field?.inputProps && field?.inputProps),
                            sx:
                              field.type === "text" || field.type === "password"
                                ? { height: "36px" }
                                : { padding: "10px 4px", height: "36px" },
                          },
                          error: error && error[field.id],
                        }}
                      />
                    </>
                  );
                })}
              </Grid>
            </>
          </DialogContentText>
        </DialogContent>
      </Popup>
      {alerModeShow && (
              <ResetFormAlert
                open={alerModeShow}
                title=""
                alertModalShow={alerModeShow}
                setAlertModelShow={setAlertModelShow}
                setIsClickReset={setIsClickReset}
              />
            )}
    </>
  );
};

export default ManageVehicleService;
